import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsBannerXinglet = XingletInterface;

export const SearchAlertsBanner = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-alerts-banner'
);
